import React from 'react'
import GatsbyConfig from '../../../gatsby-config.js'

const { siteMetadata: config } = GatsbyConfig

export default class PriceGuarantee extends React.Component {
  render() {
    const { venue } = this.props

    return (
      <div className="price-guarantee">
        <h3>Price Guarantee</h3>
        <p>
          We are confident that we are offering you a premium vacation package
          at an unbeatable rate! In fact, if you find a lower publicly available
          rate online within 30 days of booking your reservation, for a room at
          the {venue}, for the same dates, and room category, compared to our
          entire package, we will match the price and refund you the
          difference&hellip; GUARANTEED!
        </p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/price-guarantee.js